/**
 * Shared, behavior-preserving sort comparators used across pages/components.
 * Each mirrors the inline `(a, b) => a.x - b.x` callbacks they replace.
 */

/** Ascending by `stopNumber` (route stop ordering). */
export const byStopNumber = <T extends { stopNumber: number }>(
  a: T,
  b: T,
): number => a.stopNumber - b.stopNumber;

/** Ascending by `sortNr` (configured category/product ordering). */
export const bySortNr = <T extends { sortNr: number }>(a: T, b: T): number =>
  a.sortNr - b.sortNr;
